// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Orders ──────────────────────────────────────────────
   One row per order, opening to show the lines, the address and a
   private note. Reuses awk__toolbar / awk__status / acard. */

.aor__list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.aor__card { padding: 0; overflow: hidden; }

.aor__head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1.1rem;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
}

.aor__head:hover { background: #faf9f5; }

.aor__head-main { min-width: 0; }

.aor__ref {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.2rem;
  font-weight: 800;
  font-size: 0.92rem;
  letter-spacing: 0.04em;
  color: #1e2a1e;
}

.aor__who {
  margin: 0;
  font-size: 0.82rem;
  color: #6b6258;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.aor__head-side {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.aor__flow {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  font-size: 0.76rem;
  font-weight: 700;
  color: #6b6258;
}

.aor__total {
  font-weight: 800;
  font-size: 0.95rem;
  color: #1e2a1e;
}

.aor__when {
  font-size: 0.76rem;
  color: #8a8279;
  white-space: nowrap;
}

.aor__chev {
  color: #8a8279;
  transition: transform 0.2s ease;
}
.aor__chev.is-open { transform: rotate(180deg); }

/* Status pills — the shop's own set, on top of the shared .awk__status shape. */
.aor__status--new       { background: rgba(var(--admin-rust-rgb), 0.12); color: #c2410c; }
.aor__status--paid      { background: rgba(37, 99, 235, 0.1);  color: #1d4ed8; }
.aor__status--packed    { background: rgba(147, 51, 234, 0.1); color: #7e22ce; }
.aor__status--shipped   { background: rgba(22, 163, 74, 0.12); color: #15803d; }
.aor__status--collected { background: rgba(22, 163, 74, 0.12); color: #15803d; }
.aor__status--cancelled { background: rgba(220, 38, 38, 0.1);  color: #b91c1c; }

/* ── Opened ── */
.aor__body {
  padding: 0 1.1rem 1.1rem;
  border-top: 1px solid #eeece5;
}

.aor__cols {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 1.5rem;
  padding-top: 0.9rem;
}

.aor__sub {
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--admin-rust);
  margin: 0 0 0.45rem;
}

.aor__cols > div > .aor__sub:not(:first-child) { margin-top: 1rem; }

.aor__items {
  list-style: none;
  margin: 0 0 0.9rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.aor__items li {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  font-size: 0.86rem;
  color: #3a3733;
}

.aor__item-qty { font-weight: 800; color: #6b6258; flex: 0 0 auto; }
.aor__item-name { flex: 1 1 auto; min-width: 0; }
.aor__item-name em { color: #8a8279; font-style: normal; }
.aor__item-price { flex: 0 0 auto; font-variant-numeric: tabular-nums; }

.aor__sums {
  margin: 0;
  border-top: 1px solid #eeece5;
  padding-top: 0.6rem;
  font-size: 0.86rem;
}

.aor__sums div {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.15rem 0;
}

.aor__sums dt { margin: 0; color: #6b6258; }
.aor__sums dd { margin: 0; font-variant-numeric: tabular-nums; }

.aor__sums-total dt,
.aor__sums-total dd { font-weight: 800; color: #1e2a1e; }

.aor__addr {
  font-size: 0.86rem;
  color: #3a3733;
  margin: 0 0 0.5rem;
  line-height: 1.5;
}

.aor__body textarea { width: 100%; box-sizing: border-box; margin-bottom: 0.5rem; }

.aor__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  border-top: 1px solid #eeece5;
  margin-top: 1rem;
  padding-top: 0.9rem;
}

.aor__jump {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-left: auto;
}

.aor__jump label {
  font-size: 0.76rem;
  font-weight: 700;
  color: #6b6258;
}

.aor__jump select {
  padding: 0.4rem 0.6rem;
  font-size: 0.82rem;
  width: auto;
}

@media (max-width: 860px) {
  .aor__cols { grid-template-columns: 1fr; gap: 1rem; }

  .aor__head { flex-wrap: wrap; }

  .aor__head-main { flex: 1 1 100%; }

  .aor__head-side {
    flex: 1 1 100%;
    justify-content: flex-start;
    gap: 0.75rem;
  }

  .aor__chev { margin-left: auto; }

  .aor__jump { margin-left: 0; width: 100%; }
  .aor__jump select { flex: 1 1 auto; }
}
`, "",{"version":3,"sources":["webpack://./src/admin/AdminOrders.css"],"names":[],"mappings":"AAAA;;6DAE6D;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,aAAa,UAAU,EAAE,gBAAgB,EAAE;;AAE3C;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mBAAmB,mBAAmB,EAAE;;AAExC,kBAAkB,YAAY,EAAE;;AAEhC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;AACA,qBAAqB,yBAAyB,EAAE;;AAEhD,gFAAgF;AAChF,0BAA0B,6CAA6C,EAAE,cAAc,EAAE;AACzF,0BAA0B,kCAAkC,GAAG,cAAc,EAAE;AAC/E,0BAA0B,mCAAmC,EAAE,cAAc,EAAE;AAC/E,0BAA0B,mCAAmC,EAAE,cAAc,EAAE;AAC/E,0BAA0B,mCAAmC,EAAE,cAAc,EAAE;AAC/E,0BAA0B,kCAAkC,GAAG,cAAc,EAAE;;AAE/E,iBAAiB;AACjB;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,iDAAiD,gBAAgB,EAAE;;AAEnE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB,gBAAgB,EAAE,cAAc,EAAE,cAAc,EAAE;AACnE,kBAAkB,cAAc,EAAE,YAAY,EAAE;AAChD,qBAAqB,cAAc,EAAE,kBAAkB,EAAE;AACzD,mBAAmB,cAAc,EAAE,kCAAkC,EAAE;;AAEvE;EACE,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA,gBAAgB,SAAS,EAAE,cAAc,EAAE;AAC3C,gBAAgB,SAAS,EAAE,kCAAkC,EAAE;;AAE/D;sBACsB,gBAAgB,EAAE,cAAc,EAAE;;AAExD;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB,WAAW,EAAE,sBAAsB,EAAE,qBAAqB,EAAE;;AAElF;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa,0BAA0B,EAAE,SAAS,EAAE;;EAEpD,aAAa,eAAe,EAAE;;EAE9B,kBAAkB,cAAc,EAAE;;EAElC;IACE,cAAc;IACd,2BAA2B;IAC3B,YAAY;EACd;;EAEA,aAAa,iBAAiB,EAAE;;EAEhC,aAAa,cAAc,EAAE,WAAW,EAAE;EAC1C,oBAAoB,cAAc,EAAE;AACtC","sourcesContent":["/* ── Orders ──────────────────────────────────────────────\n   One row per order, opening to show the lines, the address and a\n   private note. Reuses awk__toolbar / awk__status / acard. */\n\n.aor__list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.aor__card { padding: 0; overflow: hidden; }\n\n.aor__head {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.9rem 1.1rem;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n}\n\n.aor__head:hover { background: #faf9f5; }\n\n.aor__head-main { min-width: 0; }\n\n.aor__ref {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 0.2rem;\n  font-weight: 800;\n  font-size: 0.92rem;\n  letter-spacing: 0.04em;\n  color: #1e2a1e;\n}\n\n.aor__who {\n  margin: 0;\n  font-size: 0.82rem;\n  color: #6b6258;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.aor__head-side {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.aor__flow {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  font-size: 0.76rem;\n  font-weight: 700;\n  color: #6b6258;\n}\n\n.aor__total {\n  font-weight: 800;\n  font-size: 0.95rem;\n  color: #1e2a1e;\n}\n\n.aor__when {\n  font-size: 0.76rem;\n  color: #8a8279;\n  white-space: nowrap;\n}\n\n.aor__chev {\n  color: #8a8279;\n  transition: transform 0.2s ease;\n}\n.aor__chev.is-open { transform: rotate(180deg); }\n\n/* Status pills — the shop's own set, on top of the shared .awk__status shape. */\n.aor__status--new       { background: rgba(var(--admin-rust-rgb), 0.12); color: #c2410c; }\n.aor__status--paid      { background: rgba(37, 99, 235, 0.1);  color: #1d4ed8; }\n.aor__status--packed    { background: rgba(147, 51, 234, 0.1); color: #7e22ce; }\n.aor__status--shipped   { background: rgba(22, 163, 74, 0.12); color: #15803d; }\n.aor__status--collected { background: rgba(22, 163, 74, 0.12); color: #15803d; }\n.aor__status--cancelled { background: rgba(220, 38, 38, 0.1);  color: #b91c1c; }\n\n/* ── Opened ── */\n.aor__body {\n  padding: 0 1.1rem 1.1rem;\n  border-top: 1px solid #eeece5;\n}\n\n.aor__cols {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr;\n  gap: 1.5rem;\n  padding-top: 0.9rem;\n}\n\n.aor__sub {\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--admin-rust);\n  margin: 0 0 0.45rem;\n}\n\n.aor__cols > div > .aor__sub:not(:first-child) { margin-top: 1rem; }\n\n.aor__items {\n  list-style: none;\n  margin: 0 0 0.9rem;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.aor__items li {\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n  font-size: 0.86rem;\n  color: #3a3733;\n}\n\n.aor__item-qty { font-weight: 800; color: #6b6258; flex: 0 0 auto; }\n.aor__item-name { flex: 1 1 auto; min-width: 0; }\n.aor__item-name em { color: #8a8279; font-style: normal; }\n.aor__item-price { flex: 0 0 auto; font-variant-numeric: tabular-nums; }\n\n.aor__sums {\n  margin: 0;\n  border-top: 1px solid #eeece5;\n  padding-top: 0.6rem;\n  font-size: 0.86rem;\n}\n\n.aor__sums div {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.15rem 0;\n}\n\n.aor__sums dt { margin: 0; color: #6b6258; }\n.aor__sums dd { margin: 0; font-variant-numeric: tabular-nums; }\n\n.aor__sums-total dt,\n.aor__sums-total dd { font-weight: 800; color: #1e2a1e; }\n\n.aor__addr {\n  font-size: 0.86rem;\n  color: #3a3733;\n  margin: 0 0 0.5rem;\n  line-height: 1.5;\n}\n\n.aor__body textarea { width: 100%; box-sizing: border-box; margin-bottom: 0.5rem; }\n\n.aor__actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  border-top: 1px solid #eeece5;\n  margin-top: 1rem;\n  padding-top: 0.9rem;\n}\n\n.aor__jump {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin-left: auto;\n}\n\n.aor__jump label {\n  font-size: 0.76rem;\n  font-weight: 700;\n  color: #6b6258;\n}\n\n.aor__jump select {\n  padding: 0.4rem 0.6rem;\n  font-size: 0.82rem;\n  width: auto;\n}\n\n@media (max-width: 860px) {\n  .aor__cols { grid-template-columns: 1fr; gap: 1rem; }\n\n  .aor__head { flex-wrap: wrap; }\n\n  .aor__head-main { flex: 1 1 100%; }\n\n  .aor__head-side {\n    flex: 1 1 100%;\n    justify-content: flex-start;\n    gap: 0.75rem;\n  }\n\n  .aor__chev { margin-left: auto; }\n\n  .aor__jump { margin-left: 0; width: 100%; }\n  .aor__jump select { flex: 1 1 auto; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
